import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import * as Steps from './Steps/index';
import { getSessionStorageItem, SESSION_STORAGE_COMPARE_QUOTES_KEY, SESSION_STORAGE_ABLTC_OBJECT_KEY, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../sessionStorage';
import { saveSessionEvent } from "../../../../session";
import { HeaderProgressTracker } from '../../../Common/HeaderStepper/HeaderProgressTracker';
import { OneClickProductType } from '../../../Common/Constant';
import { insurancePolicyTypes } from '../SubComponents/SelectOptions';

export default function AssetBasedLTC(props) {

  useEffect(() => { saveSessionEvent() }, [props.location])

  const path = props.location ? props.location.pathname.split("/").pop() : null;

  const sessionStorageFormState = getSessionStorageItem(SESSION_STORAGE_ABLTC_OBJECT_KEY);
  const prefill = props.location.search && props.location.search.toLowerCase().includes('prefill');
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const isEnableABLTCSurvivorshipWorkFlow = accountObj && accountObj.msEnableABLTCSurvivorshipWorkflow;

  const newFormState = {
    currentStep: 1,
    pages: {
      quoter: Steps.Quoter.DefaultFormState(),
      clientCoverage: Steps.ClientCoverage.DefaultFormState(prefill),
      insuredBasicInfo: Steps.InsuredBasicInfo.DefaultFormState(prefill),
      retrieveAccount: Steps.RetrieveAccount.DefaultFormState(prefill, isEnableABLTCSurvivorshipWorkFlow),
      yourInformation: Steps.YourInformation.DefaultFormState(prefill),
      compare: Steps.Compare.DefaultFormState(),
    },
  }

  const initialFormState = sessionStorageFormState || newFormState;

  const [formState, setFormState] = useState(initialFormState);
  const isSurvivorshipPolicy = formState.pages.retrieveAccount.insurancePolicyType === insurancePolicyTypes.SURVIVORSHIP;

  // update the formState when the url path changes the step
  useEffect(() => {
    if (!path) {
      return;
    }

    const nextStep = steps.find(s => s.path === path);

    if (!nextStep) {
      return;
    }
    const newFormState = { ...formState, currentStep: nextStep.step };
    setFormState(newFormState);
  }, [path])

  const onNext = () => {
    let nextStep;
      nextStep = steps.find(s => s.step === formState.currentStep + 1);

    if (nextStep.path === 'compare' && !formState.pages.quoter.isCompareSelected) {
      nextStep = steps.find(s => s.step === nextStep.step + 1);
    }

    if (!nextStep) {
      throw new Error("onNext did not find a next step")
    }

    const newFormState = { ...formState, currentStep: nextStep.step };

    setFormState(newFormState);
    sessionStorage.setItem(SESSION_STORAGE_ABLTC_OBJECT_KEY, JSON.stringify(newFormState));

    props.history.push(`/Products/ABLTC/${nextStep.path}`);
    window.scroll(0, 0);
  }

  const onBack = () => {
    let backStep = steps.find(s => s.step === formState.currentStep - 1);
    if (backStep) {
      if (backStep.path === 'compare' && !formState.pages.quoter.isCompareSelected) {
        backStep = steps.find(s => s.step === backStep.step - 1);
      }
    const newFormState = { ...formState, currentStep: backStep.step }

    setFormState(newFormState);
    sessionStorage.setItem(SESSION_STORAGE_ABLTC_OBJECT_KEY, JSON.stringify(newFormState));
    var redirect = '';
    redirect = `${backStep.path}`;
    props.history.push(`/Products/ABLTC/${redirect}`);
    window.scroll(0, 0);
  }
    else {
      props.history.push('/Products/Landing/ABLTC');
    }
  }

  const onFieldChange = (step, field, value) => {
    setFormState({ ...formState, pages: { ...formState.pages, [step]: { ...formState.pages[step], [field]: value } } });
  }

  const clearFormState = () =>{
    sessionStorage.removeItem(SESSION_STORAGE_ABLTC_OBJECT_KEY);
    sessionStorage.removeItem(SESSION_STORAGE_COMPARE_QUOTES_KEY);
    setFormState(newFormState);
    props.history.push('/Products/ABLTC/existing-client');
  }

  const setAllFormOnAccountNoChanged = (value = null) => {
    let newFormState = formState;
    const clientData = Steps.RetrieveAccount.DefaultFormState(prefill, isEnableABLTCSurvivorshipWorkFlow);
    const insuredData = Steps.InsuredBasicInfo.DefaultFormState(prefill);
    clientData.clientType = value || formState.pages.retrieveAccount.clientType;
    if(!value){
      clientData.officeFa = formState.pages.retrieveAccount.officeFa;
      if(formState.pages.retrieveAccount.clientType === 'Existing'){
        clientData.officeAccount = formState.pages.retrieveAccount.officeAccount;
        clientData.branchOptions = formState.pages.retrieveAccount.branchOptions;
        clientData.faNum = formState.pages.retrieveAccount.faNum;
        clientData.officeNum = formState.pages.retrieveAccount.officeNum;
      }
    }
    newFormState.pages.retrieveAccount = clientData;
    newFormState.pages.insuredBasicInfo = insuredData;
    setFormState({ ...newFormState });
  }

  const calculatePercentage = (totalStep, step, categoryStep, currentCateTotalStep) => {
    let stepPer = ((step - 1) / totalStep * 100);
    let cateCount = currentCateTotalStep === 1 ? 1 : (((categoryStep - 0.5) / currentCateTotalStep) * (100 / totalStep));
    return stepPer + cateCount;
  }

  const steps = [
    {
      step: 1,
      path: 'existing-client',
      progressTitle: 'Basics',
      component: (
        <Steps.RetrieveAccount
          formState={formState.pages.retrieveAccount}
          onFieldChange={(field, value) => onFieldChange('retrieveAccount', field, value)}
          onNext={onNext}
          onBack={onBack}
          setAllFormOnAccountNoChanged={(value)=>setAllFormOnAccountNoChanged(value)}
          fullFormState={formState}
          disableSurvivorshipDropDown={!isEnableABLTCSurvivorshipWorkFlow}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
          insuredInfoDefaultState = {Steps.InsuredBasicInfo.DefaultFormState(prefill)}
          isABLTC={true}
        />
      ),
      categoryNumber: 1,
      categoryStep: 2,
      showContainer: true,
      hideProgressTracker: false,
      percentage: 5,
    },
    {
      step: 2,
      path: 'basic-info',
      progressTitle: 'Basics',
      component: <Steps.InsuredBasicInfo
        formState={formState.pages.insuredBasicInfo}
        fullFormState={formState}
        isSurvivorshipPolicy={isSurvivorshipPolicy}
        onFieldChange={(field, value) => onFieldChange('insuredBasicInfo', field, value)}
        ageSpecs={{ min: 30, max: 80 }}
        onNext={onNext}
        onBack={onBack}
        onMultiFieldChange={(fs) => {
          setFormState(fs);
        }}
      />,
      hideProgressTracker: false,
      hideContainer: false,
      categoryNumber: 1,
      categoryStep: 3,
      progressOption: 'Client Info'
    },
    {
      step: 3,
      path: 'client-coverage',
      progressTitle: 'Basics',
      component: (
        <Steps.ClientCoverage
          formState={formState.pages.clientCoverage}
          basicInfo={formState}
          isSurvivorshipPolicy={isSurvivorshipPolicy}
          onFieldChange={(field, value) => onFieldChange('clientCoverage', field, value)}
          onNext={onNext}
          onBack={onBack}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
        />
      ),
      categoryNumber: 2,
      categoryStep: 1,
      showContainer: true,
      hideProgressTracker: false,
    },
    {
      step: 4,
      path: 'quote',
      component: <Steps.Quoter
        formState={formState.pages.quoter}
        basicInfo={formState}
        isSurvivorshipPolicy={isSurvivorshipPolicy}
        onFieldChange={(field, value) => onFieldChange('quoter', field, value)}
        onNext={onNext}
        onBack={onBack}
        history={props.history}
        productType = "LTC"
        onMultiFieldChange={(fs) => {
          setFormState(fs);
        }}
      />,
      showContainer: false,
      hideProgressTracker: true,
      hideHeader: true
    },
    {
      step: 5,
      path: 'compare',
      component: <Steps.Compare
        quoter={formState.pages.quoter}
        basicInfo={formState}
        onFieldChange={(field, value) => onFieldChange('compare', field, value)}
        onNext={onNext}
        onBack={onBack}
      />,
      setProgressHeader: false,
      hideProgressTracker: true,
    },
    {
      step: 6,
      path: 'your-info',
      component: <Steps.YourInformation
        formState={formState.pages.yourInformation}
        basicInfo={formState}
        isSurvivorshipPolicy={isSurvivorshipPolicy}
        onFieldChange={(field, value) => onFieldChange('yourInformation', field, value)}
        onNext={onNext}
        onBack={onBack}
        productType={'REQUEST_ILLUSTRATION'}
        isIllustration={true}
        onMultiFieldChange={(fs) => {
          setFormState(fs);
        }}
        oneClickProductType ={OneClickProductType.MorganStanleyLTCQ}
      />,
      showContainer: false,
      hideProgressTracker: true,
    },
    {
      step: 7,
      path: 'QuoteSuccess',
      progressTitle: 'Basics',
      component: (
        <Steps.QuoteSuccess
          yourInformation = {formState.pages.yourInformation}
          isIllustration ={true}
          clearFormState={clearFormState}
        />
      ),
      breadCrumbTitle: 'QUOTE',
      categoryNumber: 4,
      lastStep: true,
    }
  ];

  const currentStepObj = steps.find(s => s.step === formState.currentStep) || steps[0];
  const categories = steps.filter((o) => o.categoryNumber === currentStepObj.categoryNumber);
  const totalCategoriesStep = Math.max.apply(Math, categories.map(function (o) { return o.categoryStep; }))
  const percent = calculatePercentage(2, currentStepObj.categoryNumber, currentStepObj.categoryStep, totalCategoriesStep);
  return (
    <div>
      <Helmet>
        <title>Asset Based LTC</title>
      </Helmet>
      <HeaderProgressTracker currentPage={true} breadcrumbLink = {[{ name: 'PRODUCTS', href: '/Products' }, {name: 'ASSET BASED LTC', href: '/Products/Landing/ABLTC'}, currentStepObj.path === 'compare' && {name: 'QUOTE', href: '/Products/ABLTC/quote'}]} breadCrumb={`${currentStepObj.path === 'compare' ? 'COMPARE' : (currentStepObj.path === 'your-info' || currentStepObj.path === 'submitcase') ? 'ILLUSTRATION REQUEST' : 'QUOTE'}`} title='Asset Based LTC' showContainer={false} hideProgressTracker={currentStepObj.hideProgressTracker} hideHeader={currentStepObj.hideHeader} headerProductsText={true} stepName={currentStepObj.progressTitle} step={currentStepObj.categoryNumber} totalSteps={2} whiteBg={currentStepObj.whiteBackground} percent={percent}>
        {currentStepObj.component}
      </HeaderProgressTracker>
    </div>
  )
}




// WEBPACK FOOTER //
// ./src/components/Product/ABLTC/RequestIllustration/AssetBasedLTC.js